function redirectToLogin() {
    localStorage.removeItem('authState2026');
    window.location.href = '/login';
}

function isAuthError(status, body) {
    if (status === 401 || status === 403) return true;

    if (!body) return false;

    const msg = body.message?.toUpperCase?.();

    return [
        'UNAUTHORIZED',
        'TOKEN_EXPIRED',
        'INVALID_TOKEN',
        'MISSING_TOKEN',
        'ACCESS_DENIED'
    ].includes(msg);
}

export async function fetchWithAuth(url, options = {}) {
    const response = await fetch(url, options);

    let body = null;
    const contentType = response.headers.get('content-type');

    if (contentType?.includes('application/json')) {
        try {
            body = await response.clone().json();
        } catch (_) {}
    }

    // 🔐 Detecta Authorizer y sus variantes
    if (isAuthError(response.status, body)) {
        redirectToLogin();
        throw new Error(body?.message || 'Unauthorized');
    }

    // ❗ Otros errores NO auth
    if (!response.ok) {
        throw new Error(
            body?.message || `HTTP error ${response.status}`
        );
    }

    return body ?? response.json();
}